import React from 'react'
import { Route, Routes } from 'react-router'
import GrievanceAdminRoutes from './GrievanceAdminRoutes'
import ManagerLandingPage from '../app/dashboard/pages/ManagerLandingPage'
import { useAuth } from '../context/AuthContext'
import WhatsAppAdminRoutes from './WhatsAppAdminRoutes'
import GrievanceDataGridPage from '../app/admin/grievance/pages/GrievanceDataGridPage'
import FeedbackListPage from '../app/admin/feedback/pages/FeedbackListPage'

import SuggestionListPage from '../app/admin/feedback/pages/SuggestionListPage'
import GrievancePendingReportByTypePage from '../app/admin/reports/pages/GrievancePendingReportByTypePage'
import GrievancePendingReportByGroupPage from '../app/admin/reports/pages/GrievancePendingReportByGroupPage'
import GrievanceStatusReportByGroupPage from '../app/admin/reports/pages/GrievanceStatusReportByGroupPage'
import GrievanceStatusReportByTypePage from '../app/admin/reports/pages/GrievanceStatusReportByTypePage'
import ManageEmergencyContactPage from '../app/admin/cms/pages/ManageEmergencyContactPage'
import ManageCMSPagesPage from '../app/admin/cms/pages/ManageCMSPagesPage'
import ManageSuggestionPage from '../app/admin/cms/pages/ManageSuggestionPage'
import MemberRepeatedGrievanceReport from '../app/admin/reports/pages/MemeberRepeatedGrievanceReport'



function ManagerRoutes() {
  const {authUser} = useAuth()
  return (
    <>
      <Routes>
        {/* Manager */}
        {authUser.role == 2 && <Route path="/" element={ <ManagerLandingPage /> }></Route>  }
        <Route path="/grievance/data-grid" element={ <GrievanceDataGridPage /> }></Route>
        <Route path="/feedback/list" element={ <FeedbackListPage /> }></Route>
        <Route path="/suggestion/list" element={ <SuggestionListPage /> }></Route>

        <Route path="/report/grievance/pending-by-type" element={ <GrievancePendingReportByTypePage /> }></Route>
        <Route path="/report/grievance/pending-by-group" element={ <GrievancePendingReportByGroupPage /> }></Route>
        <Route path="/report/grievance/status-by-type" element={ <GrievanceStatusReportByTypePage /> }></Route>
        <Route path="/report/grievance/status-by-group" element={ <GrievanceStatusReportByGroupPage /> }></Route>
        <Route path="/report/girevance/member-repeated-grievance" element={<MemberRepeatedGrievanceReport/> }></Route>


        <Route path="/cms/emergency-contact" element={ <ManageEmergencyContactPage /> }></Route>
        <Route path="/cms/pages" element={ <ManageCMSPagesPage /> }></Route>
        <Route path="/cms/suggestion" element={ <ManageSuggestionPage /> }></Route>

      </Routes>
      <WhatsAppAdminRoutes/>
      <GrievanceAdminRoutes/>
    </>
  )
}

export default ManagerRoutes